export default __webpack_public_path__ + "static/media/chapter1.6339f050.jpg";